export default "__VITE_ASSET__XlzKyBDhsXxwmPcQu_LwOw__"